import React, { useState, useRef, useEffect } from "react"
import styled from "styled-components"
import { getIsVisibleInLocale } from "../../../../services/links"
import colors from "../../../../styles/colors"
import fonts from "../../../../styles/fonts"
import OpenIcon from "../../../../resources/img/ui/nav/open.svg"
import CloseIcon from "../../../../resources/img/ui/nav/close.svg"
import Alink from "../../Alink"

const Accordion = styled.div``

const StyledButton = styled.button`
  ${fonts.ivyStyleLight};
  padding: 0;
  border: none;
  background: ${colors.white};
  width: 100%;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors.black};
  line-height: 1.16;
  padding: 12px 30px;
  text-align: left;
  text-transform: lowercase;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #CCC;

  img {
    width: 13px;
    height: 13px;
  }
`

const Drawer = styled.div`
  height: ${(props) => (props.open ? `${props.height}px` : 0)};
  transition: height 0.3s ease;
  overflow: hidden;
`

const List = styled.div`
  display: flex;
  padding: 15px 30px;
  width: 100%;
  gap: 10px;
  background: ${colors.beige};
  min-height: 143px;
`

const Column = styled.div`
  flex: 1;
  ${fonts.ivyStyleLight};
  color: ${colors.black};
  font-size: 14px;
  text-transform: lowercase;

  a {
    padding: 3px 0;
    display: block;
    color: inherit;
    text-decoration: none;
  }
  
  a:focus {
    text-decoration: underline;
  }

  button {
    ${fonts.ivyStyleLight};
    font-size: inherit;
    line-height: inherit;
    background: transparent;
    border: none;
    text-transform: lowercase;
    display: block;
    padding: 3px 0;
  }
`

const LinkList = ({ link, handleBespokeFormPopup, closeIfActive }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [contentHeight, setContentHeight] = useState(0)
  const listRef = useRef()

  useEffect(() => {
    if (listRef.current) {
      setContentHeight(listRef.current.clientHeight)
    }
  }, [isOpen])

  return (
    <Accordion>
      <StyledButton onClick={() => setIsOpen(!isOpen)}>
        <span>{link.header}</span>
        <span>{isOpen ? <img src={CloseIcon} alt="close" /> : <img src={OpenIcon} alt="open" />}</span>
      </StyledButton>
      <Drawer height={contentHeight} open={isOpen ? 1 : 0}>
        <List ref={listRef}>
          {link.links.map((column, index) => {
            const visible = getIsVisibleInLocale(column.locale)
            if (!visible) return null
            return (
              <Column key={index}>
                {column.links.map((listedLink, i) => {
                  const visible = getIsVisibleInLocale(listedLink.locale)
                  if (!visible) return null

                  if (listedLink.openBespokeForm) {
                    return (
                      <button onClick={handleBespokeFormPopup} key={i}>
                        {listedLink.title}
                      </button>
                    )
                  }

                  if (listedLink.externalLink) {
                    return (
                      <a href={listedLink.externalLink}>
                        {listedLink.title}
                      </a>
                    )
                  }
                  return (
                    <Alink
                      to={listedLink.link}
                      key={i}
                      onClick={(e) => closeIfActive(e)}
                      prefetch={false}
                    >
                      {listedLink.title}
                    </Alink>
                  )
                })}
              </Column>
            )
          })}
        </List>
      </Drawer>
    </Accordion>
  )
}

export default LinkList
